/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecipientResolutionCandidate
 */
export interface RecipientResolutionCandidate {
    /**
     * 
     */
    provider_id: string;
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    city?: string;
    /**
     * 
     */
    state?: string;
    /**
     * 
     */
    provider_type?: string;
}

/**
 * Check if a given object implements the RecipientResolutionCandidate interface.
 */
export function instanceOfRecipientResolutionCandidate(value: object): value is RecipientResolutionCandidate {
    if (!('provider_id' in value) || value['provider_id'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function RecipientResolutionCandidateFromJSON(json: any): RecipientResolutionCandidate {
    return RecipientResolutionCandidateFromJSONTyped(json, false);
}

export function RecipientResolutionCandidateFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecipientResolutionCandidate {
    if (json == null) {
        return json;
    }
    return {
        
        'provider_id': json['provider_id'],
        'facility_id': json['facility_id'],
        'name': json['name'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'provider_type': json['provider_type'] == null ? undefined : json['provider_type'],
    };
}

export function RecipientResolutionCandidateToJSON(json: any): RecipientResolutionCandidate {
    return RecipientResolutionCandidateToJSONTyped(json, false);
}

export function RecipientResolutionCandidateToJSONTyped(value?: RecipientResolutionCandidate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'provider_id': value['provider_id'],
        'facility_id': value['facility_id'],
        'name': value['name'],
        'city': value['city'],
        'state': value['state'],
        'provider_type': value['provider_type'],
    };
}

